import axios from 'axios'
import router from '../../../router/index.js'

export const SET_FORM_DATA = 'SET_FORM_DATA'
export const SET_FORM_VALID = 'SET_FORM_VALID'
export const SET_TASK_NAME = 'SET_TASK_NAME'
export const SET_WAIT_COUNTER = 'SET_WAIT_COUNTER'
export const SET_PDF_FILE = 'SET_PDF_FILE'
export const SET_PDF_KEY = 'SET_PDF_KEY'
export const SET_PS_QR_CODE_FILE = 'SET_PS_QR_CODE_FILE'
export const SET_PS_QR_CODE_KEY = 'SET_PS_QR_CODE_KEY'
export const SET_PARCELNUMBER = 'SET_PARCELNUMBER'
export const SET_PARCELNUMBER_WITH_CHECKSUM = 'SET_PARCELNUMBER_WITH_CHECKSUM'
export const SET_TRACKING_ID = 'SET_TRACKING_ID'

const state = {
  formData: {
    order_number: '',
    name: '',
    address: '',
    postal_code: '',
    city: '',
    email: '',
    country: '',
    return_reason: '',
    return_reason_key: undefined
  },
  formIsValid: false,
  plan: undefined,
  labelType: undefined,
  price: undefined,
  errorMsg: undefined,
  taskName: undefined,
  waitCounter: 0,
  pdfFile: '',
  pdfKey: '',
  parcelShopQrCodeFile: '',
  parcelShopQrCodeKey: ''
}

const getters = {

  formIsValid(state) {
    return state.formIsValid
  },

  formDataCountry(state) {
    return state.formData.country
  },

  formDataCity(state) {
    return state.formData.city
  },

  formDataPostalCode(state) {
    return state.formData.postal_code
  }
}

const actions = {

  createReturn({ state, rootState }, selectedDropShop) {
    const fullName = state.formData.name;

    selectedDropShop = selectedDropShop || {};

    const {
      address: addressStreet,
      country: addressCountryCode,
      postal_code: addressZipCode,
      city: addressCity,
      email,
      return_reason: returnReason,
      return_reason_key: returnReasonKey,
      order_number: orderNumber
    } = state.formData

    const payload = {
      portalUuid: rootState.config.identifier,
      languageCode: rootState.lang.currentLanguage,
      returnReason: returnReason,
      returnReasonKey: returnReasonKey,
      orderNumber,
      sender: {
        fullName,
        address: {
          street: addressStreet,
          countryCode: addressCountryCode,
          zipCode: addressZipCode,
          city: addressCity
        },
        email,
        selectedDropOffPoint: {
          street: selectedDropShop.address ? selectedDropShop.address.street : undefined,
          zipCode: selectedDropShop.address ? selectedDropShop.address.zipCode : undefined,
          city: selectedDropShop.address ? selectedDropShop.address.city : undefined
        }
      }
    }

    const apigeeProxyUrl = process.env.APIGEE_PROXY_URL
    const apigeeProxyApikey = process.env.APIGEE_PROXY_APIKEY

    return axios
      .post(`${apigeeProxyUrl}/${payload.portalUuid}`, payload, { headers: { apikey: apigeeProxyApikey } })
      .then(result => result.data)
      .catch(() => {
        router.push(`/m/` + rootState.config.identifier + `/failure`)
      })
  },

  commit({ commit, rootState }, data) {

    const pdfUrl = data.signedLabelUrl
    commit('SET_PDF_FILE', pdfUrl)

    const pdfKey = data.signedLabelKey
    commit('SET_PDF_KEY', pdfKey)

    const parcelShopQrCodeFile = data.signedQrCodeUrl ? data.signedQrCodeUrl : null
    commit('SET_PS_QR_CODE_FILE', parcelShopQrCodeFile)

    const parcelShopQrCodeKey = data.signedQrCodeUrl ? data.signedQrCodeKey : null
    commit('SET_PS_QR_CODE_KEY', parcelShopQrCodeKey)

    const parcelNumber = data.parcelNumber
    commit('SET_PARCELNUMBER', parcelNumber)

    const parcelNumberWithChecksum = data.parcelNumberWithChecksum
    commit('SET_PARCELNUMBER_WITH_CHECKSUM', parcelNumberWithChecksum)

    const trackingId = data.trackingId
    commit('SET_TRACKING_ID', trackingId)

    router.push(`/m/` + rootState.config.identifier + `/success`)
  },

  sendConfirmationEmail({ state, rootState }, email) {
    const {
      name: fullName,
      address: addressStreet,
      country: addressCountryCode,
      postal_code: addressZipCode,
      city: addressCity
    } = state.formData

    const payload = {
      payload: {
        languageCode: rootState.lang.currentLanguage,
        sender: {
          fullName,
          address: {
            city: addressCity,
            street: addressStreet,
            zipCode: addressZipCode,
            countryCode: addressCountryCode,
          },
          email
        },
        parcel: {
          number: {
            number: state.parcelNumber
          }
        }
      },
      label: { key: state.pdfKey },
      parcelShopQrCode: { key: state.parcelShopQrCodeKey },
      config: rootState.config
    }

    const createReturnServiceUrl = process.env.CREATE_RETURN_SERVICE_URL

    return axios
      .post(`${createReturnServiceUrl}/return/confirmation/email`, payload, {})
      .then(result => result.data)
      .catch(err => {
        if (err.response && err.response.data && err.response.data.errorMessage) {
          throw new Error(err.response.data.errorMessage)
        }
        throw err
      })
  }
}

const mutations = {
  [SET_FORM_DATA](state, value) {
    state.formData = value
  },

  [SET_FORM_VALID](state, isValid) {
    state.formIsValid = isValid
  },

  [SET_WAIT_COUNTER](state, value) {
    state.waitCounter = value
  },

  [SET_PDF_FILE](state, value) {
    state.pdfFile = value
  },

  [SET_PDF_KEY](state, value) {
    state.pdfKey = value
  },

  [SET_PS_QR_CODE_FILE](state, value) {
    state.parcelShopQrCodeFile = value
  },

  [SET_PS_QR_CODE_KEY](state, value) {
    state.parcelShopQrCodeKey = value
  },

  [SET_PARCELNUMBER](state, value) {
    state.parcelNumber = value
  },

  [SET_PARCELNUMBER_WITH_CHECKSUM](state, value) {
    state.parcelNumberWithChecksum = value
  },

  [SET_TRACKING_ID](state, value) {
    state.trackingId = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/inputData/index.js